import { ServiceSessionRecoveryEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { setCallWrapupTime } from '../callHandlers/callStateHandler';

function handleSessionRecoveryStarted(
  context: InboxContext,
  event: ServiceSessionRecoveryEvent,
) {
  const task = TasksModule.getTaskBySessionSid(event.sessionSid);

  if (!task) {
    return;
  }

  if (context.userId === event.userId) {
    // pass task.id, not event.sessionSid: the task may still be keyed by
    // callId, and setCallWrapupTime looks it up again by the id we give it
    setCallWrapupTime(
      context,
      task.id,
      event.timestamp,
      event.recoveryAllowedMs,
    );
  }
}

export default handleSessionRecoveryStarted;
